(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/auth/assets/javascripts/auth-container.js') >= 0) return;  svs.modules.push('/components/marketplace/auth/assets/javascripts/auth-container.js');
'use strict';

const auth = svs.components.marketplaceData.auth;
const selectors = svs.components.marketplaceData.selectors;
const AuthComponent = svs.components.marketplace.auth.AuthComponent;
const mapStateToProps = (state, _ref) => {
  let groupId = _ref.groupId,
    permission = _ref.permission;
  const _ref2 = selectors.members.selectMe(state, {
      groupId
    }) || {},
    role = _ref2.role;
  if (!role) {
    return {
      isAuthorized: false
    };
  }
  const checkIfAuthorized = auth.roles.withRole(role);
  return {
    isAuthorized: Array.isArray(permission) ? permission.every(perm => checkIfAuthorized(perm)) : checkIfAuthorized(permission)
  };
};
setGlobal('svs.components.marketplace.auth.AuthContainer', ReactRedux.connect(mapStateToProps)(AuthComponent));

 })(window);